// Product translations for different languages
// Structure: productTranslations[productId][language][field]

interface ProductTranslation {
  description: string;
  shortSpecs: string[];
}

interface ProductLanguages {
  [language: string]: ProductTranslation;
}

export interface ProductTranslations {
  [productId: string]: ProductLanguages;
}

export const productTranslations: ProductTranslations = {
  "felco-2": {
    "fr": {
      "description": "Sécateur polyvalent classique",
      "shortSpecs": ["Pour droitier", "Grande main", "Polyvalent"]
    },
    "de": {
      "description": "Klassische Universalschere",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Vielseitig"]
    },
    "nl": {
      "description": "Klassieke allround snoeischaar",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Veelzijdig"]
    },
    "es": {
      "description": "Tijera de podar clásica de uso general",
      "shortSpecs": ["Para diestros", "Mano grande", "Multiuso"]
    },
    "it": {
      "description": "Forbici da potatura classiche per uso generale",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Multiuso"]
    }
  },
  "felco-4": {
    "fr": {
      "description": "Sécateur pour vergers et vignobles",
      "shortSpecs": ["Pour droitier", "Grande main", "Usage vergers et vignobles"]
    },
    "de": {
      "description": "Gartenschere für Obstgärten und Weinberge",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Obstgarten und Weinberg"]
    },
    "nl": {
      "description": "Snoeischaar voor boomgaarden en wijngaarden",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Boomgaard en wijngaard gebruik"]
    },
    "es": {
      "description": "Tijera de podar para huertos y viñedos",
      "shortSpecs": ["Para diestros", "Mano grande", "Uso en huertos y viñedos"]
    },
    "it": {
      "description": "Forbici da potatura per frutteti e vigneti",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Uso frutteti e vigneti"]
    }
  },
  "felco-5": {
    "fr": {
      "description": "Sécateur spécialisé pour le travail en verger",
      "shortSpecs": ["Pour droitier", "Grande main", "Spécifique verger"]
    },
    "de": {
      "description": "Spezialisierte Gartenschere für Obstgartenarbeit",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Obstgarten spezifisch"]
    },
    "nl": {
      "description": "Gespecialiseerde snoeischaar voor boomgaardwerk",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Boomgaard specifiek"]
    },
    "es": {
      "description": "Tijera de podar especializada para trabajo en huertos",
      "shortSpecs": ["Para diestros", "Mano grande", "Específico para huertos"]
    },
    "it": {
      "description": "Forbici da potatura specializzate per lavori in frutteto",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Specifico per frutteti"]
    }
  },
  "felco-6": {
    "fr": {
      "description": "Sécateur compact pour mains moyennes",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Usage polyvalent"]
    },
    "de": {
      "description": "Kompakte Gartenschere für mittelgroße Hände",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Vielseitiger Einsatz"]
    },
    "nl": {
      "description": "Compacte snoeischaar voor gemiddelde handen",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Veelzijdig gebruik"]
    },
    "es": {
      "description": "Tijera de podar compacta para manos medianas",
      "shortSpecs": ["Para diestros", "Mano mediana", "Uso versátil"]
    },
    "it": {
      "description": "Forbici da potatura compatte per mani medie",
      "shortSpecs": ["Per destrorsi", "Mano media", "Uso versatile"]
    }
  },
  "felco-6-premium-se": {
    "fr": {
      "description": "Édition spéciale premium du modèle FELCO 6",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Design premium"]
    },
    "de": {
      "description": "Premium Sonderedition des FELCO 6 Modells",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Premium Design"]
    },
    "nl": {
      "description": "Premium speciale editie van het FELCO 6 model",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Premium ontwerp"]
    },
    "es": {
      "description": "Edición especial premium del modelo FELCO 6",
      "shortSpecs": ["Para diestros", "Mano mediana", "Diseño premium"]
    },
    "it": {
      "description": "Edizione speciale premium del modello FELCO 6",
      "shortSpecs": ["Per destrorsi", "Mano media", "Design premium"]
    }
  },
  "felco-6-ed-stephane-marie": {
    "fr": {
      "description": "Sécateur édition spéciale conçu avec Stéphane Marie",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Pour fleurs, vignes et pépinières"]
    },
    "de": {
      "description": "Sonderedition Gartenschere entworfen mit Stéphane Marie",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Für Blumen, Reben und Baumschulen"]
    },
    "nl": {
      "description": "Speciale editie snoeischaar ontworpen met Stéphane Marie",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Voor bloemen, wijngaarden en kwekerijen"]
    },
    "es": {
      "description": "Tijera de podar edición especial diseñada con Stéphane Marie",
      "shortSpecs": ["Para diestros", "Mano mediana", "Para flores, viñas y viveros"]
    },
    "it": {
      "description": "Forbici da potatura edizione speciale progettate con Stéphane Marie",
      "shortSpecs": ["Per destrorsi", "Mano media", "Per fiori, viti e vivai"]
    }
  },
  "felco-7": {
    "fr": {
      "description": "Sécateur pour travaux forestiers et viticoles avec poignée rotative",
      "shortSpecs": ["Pour droitier", "Grande main", "Haute performance"]
    },
    "de": {
      "description": "Gartenschere für Forst- und Weinbergarbeit mit rotierendem Griff",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Hochleistung"]
    },
    "nl": {
      "description": "Snoeischaar voor bosbouw en wijngaardwerk met roterende handgreep",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Hoge prestaties"]
    },
    "es": {
      "description": "Tijera de podar para trabajos forestales y vitícolas con mango giratorio",
      "shortSpecs": ["Para diestros", "Mano grande", "Alto rendimiento"]
    },
    "it": {
      "description": "Forbici da potatura per lavori forestali e viticoli con impugnatura rotante",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Alte prestazioni"]
    }
  },
  "felco-8": {
    "fr": {
      "description": "Sécateur ergonomique",
      "shortSpecs": ["Pour droitier", "Grande main", "Design ergonomique"]
    },
    "de": {
      "description": "Ergonomische Gartenschere",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Ergonomisches Design"]
    },
    "nl": {
      "description": "Ergonomische snoeischaar",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Ergonomisch ontwerp"]
    },
    "es": {
      "description": "Tijera de podar ergonómica",
      "shortSpecs": ["Para diestros", "Mano grande", "Diseño ergonómico"]
    },
    "it": {
      "description": "Forbici da potatura ergonomiche",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Design ergonomico"]
    }
  },
  "felco-8-premium-se": {
    "fr": {
      "description": "Édition spéciale premium du modèle FELCO 8",
      "shortSpecs": ["Pour droitier", "Design premium ergonomique"]
    },
    "de": {
      "description": "Premium Sonderedition des FELCO 8 Modells",
      "shortSpecs": ["Rechtshändig", "Ergonomisches Premium Design"]
    },
    "nl": {
      "description": "Premium speciale editie van het FELCO 8 model",
      "shortSpecs": ["Rechtshandig", "Ergonomisch premium ontwerp"]
    },
    "es": {
      "description": "Edición especial premium del modelo FELCO 8",
      "shortSpecs": ["Para diestros", "Diseño premium ergonómico"]
    },
    "it": {
      "description": "Edizione speciale premium del modello FELCO 8",
      "shortSpecs": ["Per destrorsi", "Design premium ergonomico"]
    }
  },
  "felco-8-ed-stephane-marie": {
    "fr": {
      "description": "Sécateur ergonomique édition spéciale conçu avec Stéphane Marie",
      "shortSpecs": ["Pour droitier", "Grande main", "Polyvalent ergonomique"]
    },
    "de": {
      "description": "Ergonomische Sonderedition Gartenschere entworfen mit Stéphane Marie",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Vielseitig ergonomisch"]
    },
    "nl": {
      "description": "Ergonomische speciale editie snoeischaar ontworpen met Stéphane Marie",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Veelzijdig ergonomisch"]
    },
    "es": {
      "description": "Tijera de podar ergonómica edición especial diseñada con Stéphane Marie",
      "shortSpecs": ["Para diestros", "Mano grande", "Multiuso ergonómico"]
    },
    "it": {
      "description": "Forbici da potatura ergonomiche edizione speciale progettate con Stéphane Marie",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Multiuso ergonomico"]
    }
  },
  "felco-6-elite": {
    "fr": {
      "description": "Version élite du sécateur compact pour mains moyennes",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Usage polyvalent"]
    },
    "de": {
      "description": "Elite-Version der kompakten Gartenschere für mittelgroße Hände",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Vielseitiger Einsatz"]
    },
    "nl": {
      "description": "Elite versie van de compacte snoeischaar voor gemiddelde handen",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Veelzijdig gebruik"]
    },
    "es": {
      "description": "Versión élite de la tijera de podar compacta para manos medianas",
      "shortSpecs": ["Para diestros", "Mano mediana", "Uso versátil"]
    },
    "it": {
      "description": "Versione elite delle forbici da potatura compatte per mani medie",
      "shortSpecs": ["Per destrorsi", "Mano media", "Uso versatile"]
    }
  },
  "felco-8-elite": {
    "fr": {
      "description": "Version élite du sécateur ergonomique",
      "shortSpecs": ["Pour droitier", "Grande main", "Design ergonomique"]
    },
    "de": {
      "description": "Elite-Version der ergonomischen Gartenschere",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Ergonomisches Design"]
    },
    "nl": {
      "description": "Elite versie van de ergonomische snoeischaar",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Ergonomisch ontwerp"]
    },
    "es": {
      "description": "Versión élite de la tijera de podar ergonómica",
      "shortSpecs": ["Para diestros", "Mano grande", "Diseño ergonómico"]
    },
    "it": {
      "description": "Versione elite delle forbici da potatura ergonomiche",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Design ergonomico"]
    }
  },
  "felco-9": {
    "fr": {
      "description": "Sécateur pour gaucher",
      "shortSpecs": ["Pour gaucher", "Grande main", "Design ergonomique"]
    },
    "de": {
      "description": "Linkshänder Gartenschere",
      "shortSpecs": ["Linkshändig", "Große Hand", "Ergonomisches Design"]
    },
    "nl": {
      "description": "Linkshandige snoeischaar",
      "shortSpecs": ["Linkshandig", "Grote hand", "Ergonomisch ontwerp"]
    },
    "es": {
      "description": "Tijera de podar para zurdos",
      "shortSpecs": ["Para zurdos", "Mano grande", "Diseño ergonómico"]
    },
    "it": {
      "description": "Forbici da potatura per mancini",
      "shortSpecs": ["Per mancini", "Mano grande", "Design ergonomico"]
    }
  },
  "felco-10": {
    "fr": {
      "description": "Sécateur pour gaucher pour vergers et vignobles avec poignée rotative",
      "shortSpecs": ["Pour gaucher", "Grande main", "Usage vergers et vignobles"]
    },
    "de": {
      "description": "Linkshänder Gartenschere für Obstgärten und Weinberge mit rotierendem Griff",
      "shortSpecs": ["Linkshändig", "Große Hand", "Obstgarten und Weinberg"]
    },
    "nl": {
      "description": "Linkshandige snoeischaar voor boomgaarden en wijngaarden met roterende handgreep",
      "shortSpecs": ["Linkshandig", "Grote hand", "Boomgaard en wijngaard gebruik"]
    },
    "es": {
      "description": "Tijera de podar para zurdos para huertos y viñedos con mango giratorio",
      "shortSpecs": ["Para zurdos", "Mano grande", "Uso en huertos y viñedos"]
    },
    "it": {
      "description": "Forbici da potatura per mancini per frutteti e vigneti con impugnatura rotante",
      "shortSpecs": ["Per mancini", "Mano grande", "Uso frutteti e vigneti"]
    }
  },
  "felco-11": {
    "fr": {
      "description": "Sécateur pour fleurs et travaux de pépinière",
      "shortSpecs": ["Pour droitier", "Grande main", "Spécialisé pour taille délicate"]
    },
    "de": {
      "description": "Gartenschere für Blumen und Baumschularbeit",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Spezialisiert für feinen Schnitt"]
    },
    "nl": {
      "description": "Snoeischaar voor bloemen en kwekerij werk",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Gespecialiseerd voor delicaat snoeien"]
    },
    "es": {
      "description": "Tijera de podar para flores y trabajo de vivero",
      "shortSpecs": ["Para diestros", "Mano grande", "Especializada para poda delicada"]
    },
    "it": {
      "description": "Forbici da potatura per fiori e lavori di vivaio",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Specializzate per potatura delicata"]
    }
  },
  "felco-12": {
    "fr": {
      "description": "Sécateur compact pour vergers et vignobles avec poignée rotative",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Usage vergers et vignobles"]
    },
    "de": {
      "description": "Kompakte Gartenschere für Obstgärten und Weinberge mit rotierendem Griff",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Obstgarten und Weinberg"]
    },
    "nl": {
      "description": "Compacte snoeischaar voor boomgaarden en wijngaarden met roterende handgreep",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Boomgaard en wijngaard gebruik"]
    },
    "es": {
      "description": "Tijera de podar compacta para huertos y viñedos con mango giratorio",
      "shortSpecs": ["Para diestros", "Mano mediana", "Uso en huertos y viñedos"]
    },
    "it": {
      "description": "Forbici da potatura compatte per frutteti e vigneti con impugnatura rotante",
      "shortSpecs": ["Per destrorsi", "Mano media", "Uso frutteti e vigneti"]
    }
  },
  "felco-13": {
    "fr": {
      "description": "Sécateur pour vignobles et aménagement paysager",
      "shortSpecs": ["Pour droitier", "Grande main", "Design spécialisé"]
    },
    "de": {
      "description": "Gartenschere für Weinberge und Landschaftsbau",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Spezialisiertes Design"]
    },
    "nl": {
      "description": "Snoeischaar voor wijngaarden en landschapsbeheer",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Gespecialiseerd ontwerp"]
    },
    "es": {
      "description": "Tijera de podar para viñedos y paisajismo",
      "shortSpecs": ["Para diestros", "Mano grande", "Diseño especializado"]
    },
    "it": {
      "description": "Forbici da potatura per vigneti e paesaggistica",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Design specializzato"]
    }
  },
  "felco-14": {
    "fr": {
      "description": "Sécateur compact pour petites mains",
      "shortSpecs": ["Pour droitier", "Petite main", "Usage polyvalent"]
    },
    "de": {
      "description": "Kompakte Gartenschere für kleine Hände",
      "shortSpecs": ["Rechtshändig", "Kleine Hand", "Vielseitiger Einsatz"]
    },
    "nl": {
      "description": "Compacte snoeischaar voor kleine handen",
      "shortSpecs": ["Rechtshandig", "Kleine hand", "Veelzijdig gebruik"]
    },
    "es": {
      "description": "Tijera de podar compacta para manos pequeñas",
      "shortSpecs": ["Para diestros", "Mano pequeña", "Uso versátil"]
    },
    "it": {
      "description": "Forbici da potatura compatte per mani piccole",
      "shortSpecs": ["Per destrorsi", "Mano piccola", "Uso versatile"]
    }
  },
  "felco-14-ed-stephane-marie": {
    "fr": {
      "description": "Sécateur compact édition spéciale conçu avec Stéphane Marie",
      "shortSpecs": ["Pour droitier", "Petite main", "Polyvalent"]
    },
    "de": {
      "description": "Kompakte Sonderedition Gartenschere entworfen mit Stéphane Marie",
      "shortSpecs": ["Rechtshändig", "Kleine Hand", "Vielseitig"]
    },
    "nl": {
      "description": "Compacte speciale editie snoeischaar ontworpen met Stéphane Marie",
      "shortSpecs": ["Rechtshandig", "Kleine hand", "Veelzijdig"]
    },
    "es": {
      "description": "Tijera de podar compacta edición especial diseñada con Stéphane Marie",
      "shortSpecs": ["Para diestros", "Mano pequeña", "Multiuso"]
    },
    "it": {
      "description": "Forbici da potatura compatte edizione speciale progettate con Stéphane Marie",
      "shortSpecs": ["Per destrorsi", "Mano piccola", "Multiuso"]
    }
  },
  "felco-15": {
    "fr": {
      "description": "Sécateur compact pour travail viticole avec poignée rotative",
      "shortSpecs": ["Pour droitier", "Petite main", "Spécifique vignoble"]
    },
    "de": {
      "description": "Kompakte Gartenschere für Weinbergarbeit mit rotierendem Griff",
      "shortSpecs": ["Rechtshändig", "Kleine Hand", "Weinberg spezifisch"]
    },
    "nl": {
      "description": "Compacte snoeischaar voor wijngaardwerk met roterende handgreep",
      "shortSpecs": ["Rechtshandig", "Kleine hand", "Wijngaard specifiek"]
    },
    "es": {
      "description": "Tijera de podar compacta para trabajo en viñedos con mango giratorio",
      "shortSpecs": ["Para diestros", "Mano pequeña", "Específico para viñedos"]
    },
    "it": {
      "description": "Forbici da potatura compatte per lavori in vigna con impugnatura rotante",
      "shortSpecs": ["Per destrorsi", "Mano piccola", "Specifico per vigneti"]
    }
  },
  "felco-16": {
    "fr": {
      "description": "Sécateur pour gaucher pour applications multiples",
      "shortSpecs": ["Pour gaucher", "Main moyenne", "Usage polyvalent"]
    },
    "de": {
      "description": "Linkshänder Gartenschere für vielfältige Anwendungen",
      "shortSpecs": ["Linkshändig", "Mittlere Hand", "Vielseitiger Einsatz"]
    },
    "nl": {
      "description": "Linkshandige snoeischaar voor meerdere toepassingen",
      "shortSpecs": ["Linkshandig", "Gemiddelde hand", "Veelzijdig gebruik"]
    },
    "es": {
      "description": "Tijera de podar para zurdos para múltiples aplicaciones",
      "shortSpecs": ["Para zurdos", "Mano mediana", "Uso versátil"]
    },
    "it": {
      "description": "Forbici da potatura per mancini per applicazioni multiple",
      "shortSpecs": ["Per mancini", "Mano media", "Uso versatile"]
    }
  },
  "felco-17": {
    "fr": {
      "description": "Sécateur pour gaucher pour applications multiples avec poignée rotative",
      "shortSpecs": ["Pour gaucher", "Main moyenne", "Usage polyvalent"]
    },
    "de": {
      "description": "Linkshänder Gartenschere für vielfältige Anwendungen mit rotierendem Griff",
      "shortSpecs": ["Linkshändig", "Mittlere Hand", "Vielseitiger Einsatz"]
    },
    "nl": {
      "description": "Linkshandige snoeischaar voor meerdere toepassingen met roterende handgreep",
      "shortSpecs": ["Linkshandig", "Gemiddelde hand", "Veelzijdig gebruik"]
    },
    "es": {
      "description": "Tijera de podar para zurdos para múltiples aplicaciones con mango giratorio",
      "shortSpecs": ["Para zurdos", "Mano mediana", "Uso versátil"]
    },
    "it": {
      "description": "Forbici da potatura per mancini per applicazioni multiple con impugnatura rotante",
      "shortSpecs": ["Per mancini", "Mano media", "Uso versatile"]
    }
  },
  "felco-19": {
    "fr": {
      "description": "Sécateur haute performance",
      "shortSpecs": ["Pour droitier", "Grande main", "Qualité professionnelle"]
    },
    "de": {
      "description": "Hochleistungs-Gartenschere",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Professionelle Qualität"]
    },
    "nl": {
      "description": "Hoge prestaties snoeischaar",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Professionele kwaliteit"]
    },
    "es": {
      "description": "Tijera de podar de alto rendimiento",
      "shortSpecs": ["Para diestros", "Mano grande", "Grado profesional"]
    },
    "it": {
      "description": "Forbici da potatura ad alte prestazioni",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Qualità professionale"]
    }
  },
  "felco-20": {
    "fr": {
      "description": "Sécateur universel pour travaux forestiers et de pépinière",
      "shortSpecs": ["Design universel", "Usage forestier et pépinière"]
    },
    "de": {
      "description": "Universelle Gartenschere für Forst- und Baumschularbeit",
      "shortSpecs": ["Universelles Design", "Forst- und Baumschulgebrauch"]
    },
    "nl": {
      "description": "Universele snoeischaar voor bosbouw en kwekerij werk",
      "shortSpecs": ["Universeel ontwerp", "Bosbouw en kwekerij gebruik"]
    },
    "es": {
      "description": "Tijera de podar universal para trabajos forestales y de vivero",
      "shortSpecs": ["Diseño universal", "Uso forestal y de vivero"]
    },
    "it": {
      "description": "Forbici da potatura universali per lavori forestali e di vivaio",
      "shortSpecs": ["Design universale", "Uso forestale e vivaio"]
    }
  },
  "felco-31": {
    "fr": {
      "description": "Sécateur universel pour vergers, haies et aménagement paysager",
      "shortSpecs": ["Design universel", "Grande main", "Applications multiples"]
    },
    "de": {
      "description": "Universelle Gartenschere für Obstgärten, Hecken und Landschaftsbau",
      "shortSpecs": ["Universelles Design", "Große Hand", "Vielfältige Anwendungen"]
    },
    "nl": {
      "description": "Universele snoeischaar voor boomgaarden, heggen en landschapsbeheer",
      "shortSpecs": ["Universeel ontwerp", "Grote hand", "Meerdere toepassingen"]
    },
    "es": {
      "description": "Tijera de podar universal para huertos, setos y paisajismo",
      "shortSpecs": ["Diseño universal", "Mano grande", "Múltiples aplicaciones"]
    },
    "it": {
      "description": "Forbici da potatura universali per frutteti, siepi e paesaggistica",
      "shortSpecs": ["Design universale", "Mano grande", "Applicazioni multiple"]
    }
  },
  "felco-32": {
    "fr": {
      "description": "Sécateur universel pour applications multiples",
      "shortSpecs": ["Design universel", "Grande main", "Applications multiples"]
    },
    "de": {
      "description": "Universelle Gartenschere für vielfältige Anwendungen",
      "shortSpecs": ["Universelles Design", "Große Hand", "Vielfältige Anwendungen"]
    },
    "nl": {
      "description": "Universele snoeischaar voor meerdere toepassingen",
      "shortSpecs": ["Universeel ontwerp", "Grote hand", "Meerdere toepassingen"]
    },
    "es": {
      "description": "Tijera de podar universal para múltiples aplicaciones",
      "shortSpecs": ["Diseño universal", "Mano grande", "Múltiples aplicaciones"]
    },
    "it": {
      "description": "Forbici da potatura universali per applicazioni multiple",
      "shortSpecs": ["Design universale", "Mano grande", "Applicazioni multiple"]
    }
  },
  "felco-50": {
    "fr": {
      "description": "Sécateur professionnel haute performance",
      "shortSpecs": ["Pour droitier", "Grande main", "Qualité professionnelle"]
    },
    "de": {
      "description": "Hochleistungs-Profigartenschere",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Professionelle Qualität"]
    },
    "nl": {
      "description": "Professionele hoge prestaties snoeischaar",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Professionele kwaliteit"]
    },
    "es": {
      "description": "Tijera de podar profesional de alto rendimiento",
      "shortSpecs": ["Para diestros", "Mano grande", "Grado profesional"]
    },
    "it": {
      "description": "Forbici da potatura professionali ad alte prestazioni",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Qualità professionale"]
    }
  },
  "felco-51": {
    "fr": {
      "description": "Sécateur professionnel avec haute capacité de coupe",
      "shortSpecs": ["Pour droitier", "Grande main", "Qualité professionnelle"]
    },
    "de": {
      "description": "Profigartenschere mit hoher Schnittkapazität",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Professionelle Qualität"]
    },
    "nl": {
      "description": "Professionele snoeischaar met hoge snijcapaciteit",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Professionele kwaliteit"]
    },
    "es": {
      "description": "Tijera de podar profesional con alta capacidad de corte",
      "shortSpecs": ["Para diestros", "Mano grande", "Grado profesional"]
    },
    "it": {
      "description": "Forbici da potatura professionali con alta capacità di taglio",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Qualità professionale"]
    }
  },
  "felco-100": {
    "fr": {
      "description": "Sécateur spécialisé pour fleurs et roses",
      "shortSpecs": ["Pour droitier", "Grande main", "Spécifique fleurs"]
    },
    "de": {
      "description": "Spezialisierte Gartenschere für Blumen und Rosen",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Blumen spezifisch"]
    },
    "nl": {
      "description": "Gespecialiseerde snoeischaar voor bloemen en rozen",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Bloemen specifiek"]
    },
    "es": {
      "description": "Tijera de podar especializada para flores y rosas",
      "shortSpecs": ["Para diestros", "Mano grande", "Específico para flores"]
    },
    "it": {
      "description": "Forbici da potatura specializzate per fiori e rose",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Specifico per fiori"]
    }
  },
  "felco-171m": {
    "fr": {
      "description": "Sécateur polyvalent pour applications multiples",
      "shortSpecs": ["Pour droitier", "Main moyenne", "Polyvalent"]
    },
    "de": {
      "description": "Universalschere für vielfältige Anwendungen",
      "shortSpecs": ["Rechtshändig", "Mittlere Hand", "Vielseitig"]
    },
    "nl": {
      "description": "Universele snoeischaar voor meerdere toepassingen",
      "shortSpecs": ["Rechtshandig", "Gemiddelde hand", "Veelzijdig"]
    },
    "es": {
      "description": "Tijera de podar versátil para múltiples aplicaciones",
      "shortSpecs": ["Para diestros", "Mano mediana", "Multiuso"]
    },
    "it": {
      "description": "Forbici da potatura versatili per applicazioni multiple",
      "shortSpecs": ["Per destrorsi", "Mano media", "Multiuso"]
    }
  },
  "felco-171l": {
    "fr": {
      "description": "Sécateur polyvalent pour applications multiples",
      "shortSpecs": ["Pour droitier", "Grande main", "Polyvalent"]
    },
    "de": {
      "description": "Universalschere für vielfältige Anwendungen",
      "shortSpecs": ["Rechtshändig", "Große Hand", "Vielseitig"]
    },
    "nl": {
      "description": "Universele snoeischaar voor meerdere toepassingen",
      "shortSpecs": ["Rechtshandig", "Grote hand", "Veelzijdig"]
    },
    "es": {
      "description": "Tijera de podar versátil para múltiples aplicaciones",
      "shortSpecs": ["Para diestros", "Mano grande", "Multiuso"]
    },
    "it": {
      "description": "Forbici da potatura versatili per applicazioni multiple",
      "shortSpecs": ["Per destrorsi", "Mano grande", "Multiuso"]
    }
  }
}; 